import PageLayout from "../../components/common/PageLayout";
import Body from "../../components/common/Body";
import { AppBar } from 'components/common';
import { useState } from 'react';
import VoiceSetting from './components/VoiceSetting';
import LanguageSetting from './components/LanguageSetting';
import useVoiceSetting from 'hooks/setting/useVoiceSetting';

type languageSettingType = 'lang' | 'voice';

interface LanguageMenuItem {
  id: languageSettingType;
  menu: string;
}

const Language = () => {
  const [menu, setMenu] = useState<languageSettingType>('lang');
  const [selectedLanguage, setSelectedLanguage] = useState<string>(BResource.getSettingLocale());
  const { selectedLocale, updateLocale, filteredLocaleList, filteredCurrentLocale } = useVoiceSetting();

  const languageMenu: LanguageMenuItem[] = [
    { id: 'lang', menu: brsc.feature_system_language },
    { id: 'voice', menu: brsc.feature_voice_translation },
  ];

  const handleBack = () => {
    saveLanguage();
  };

  const saveLanguage = () => {
    if (selectedLanguage !== BResource.getSettingLocale()) {
      const msg = brsc.change_language.replace('\n', '<br>');
      const param = {
        btnNum: 2,
        classname: ['material-popup'],
      };
      CommonUI.showDialogV2(msg, param, function (result: boolean) {
        if (result) {
          BResource.setSettingLocale(selectedLanguage);
        } else {
          Transition.back();
        }
      });
    } else {
      Transition.back();
    }
  };

  return (
    <PageLayout>
      <AppBar title={brsc.lang} onBack={handleBack} leadingIcon="icons/ic_arrow_left.svg" className="border-none" />
      <Body className="flex flex-col bg-base-bg-default px-4 pb-5 ">
        {/* 메뉴 */}
        <div className="mb-4 flex w-full items-center gap-2 px-4">
          {languageMenu.map((data) => {
            return (
              <div onClick={() => setMenu(data.id)} key={data.id} className="flex flex-1 flex-col items-center justify-center gap-1 px-2 py-1">
                {data.id === menu ? (
                  <>
                    <div className="typography-headline-md">{data.menu}</div>
                    <div className="h-1 w-8 rounded-xs bg-base-bg-focus"></div>
                  </>
                ) : (
                  <>
                    <div className="typography-headline-md text-base-txt-tertiary">{data.menu}</div>
                    <div className="h-1"></div>
                  </>
                )}
              </div>
            );
          })}
        </div>

        {/* 설정 */}
        <div className="w-full h-screen rounded-xl overflow-y-auto">
          <div className="flex w-full flex-col px-5 pb-2 bg-base-bg-strong rounded-xl">
            {menu === 'lang' ? <LanguageSetting selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} />
              : <VoiceSetting selectedLocale={selectedLocale} updateLocale={updateLocale} filteredLocaleList={filteredLocaleList} filteredCurrentLocale={filteredCurrentLocale} />}
          </div>
        </div>
      </Body>
    </PageLayout>
  );
};

export default Language;